import { GreeterEvent } from "@greeter/core";
import { DateFactory } from "@greeter/date";
import { addHours } from "date-fns";

export const mockGreeterEvent: GreeterEvent = {
  id: "asdf",
  venueId: "",
  name: "Tessa's pub crawl",
  description: "Blabla",
  startsAt: DateFactory.create(),
  endsAt: addHours(DateFactory.create(), 1),
  entryPrice: 100,
  dressCode: "Ingen",
  coverAsset: {
      id: "",
      name: "",
      root: "",
      path: "",
      uri: "",
      sizes: []
  },
  coverUrl: "http://placekitten.com/200/300",
};
